// extracted by mini-css-extract-plugin
export var typingIndicator = "_pu-0";